import axiosInstance from "./axiosAPI";

export default axiosInstance;
